import { Globe, Server, Check } from "lucide-react";
import { COMPANY_INFO } from "../data/constants";

export const EnterpriseCard = ({ pkg, type }) => {
  return (
    <div
      className="package-card bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 card-hover"
      data-testid={`enterprise-card-${pkg.speed}`}
    >
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-2xl mb-6">
          {type === "dedicado" ? (
            <Globe className="w-8 h-8 text-orange-500" />
          ) : (
            <Server className="w-8 h-8 text-orange-500" />
          )}
        </div>
        
        <div className="text-6xl font-bold text-gray-900 mb-2">{pkg.speed}</div>
        <div className="text-xl text-gray-500 mb-6">Mbps</div>
        
        <ul className="text-left space-y-3 mb-8">
          {pkg.features.map((feature, idx) => (
            <li key={idx} className="flex items-center gap-3 text-gray-600">
              <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
              {feature}
            </li>
          ))}
          <li className="flex items-center gap-3 text-gray-600">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
            Soporte prioritario
          </li>
        </ul>
        
        <a
          href={COMPANY_INFO.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full py-4 rounded-full font-semibold bg-gray-900 text-white hover:bg-orange-500 transition-all"
        >
          Solicitar Cotización
        </a>
      </div>
    </div>
  );
};
